import TokenService from "./token.service";
import store from "@/store";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const setup = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      // Don't retry for auth/refresh endpoints themselves
      const isAuthUrl =
        originalConfig.url?.includes("/Auth/RefreshToken") ||
        originalConfig.url?.includes("/auth/signin") ||
        originalConfig.url?.includes("/Auth/Login");

      if (isAuthUrl || !err.response || err.response.status !== 401) {
        return Promise.reject(err);
      }

      if (originalConfig._retry) {
        // Already retried — log out and redirect with return URL
        TokenService.removeUser();
        const redirect = encodeURIComponent(
          window.location.pathname + window.location.search,
        );
        window.location.href = `/giris?uyari=1&redirect=${redirect}`;
        return Promise.reject(err);
      }

      if (isRefreshing) {
        // Queue this request until refresh is done
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalConfig.headers["Authorization"] = "Bearer " + token;
            return axiosInstance(originalConfig);
          })
          .catch((e) => Promise.reject(e));
      }

      originalConfig._retry = true;
      isRefreshing = true;

      try {
        const rs = await axiosInstance.post("/Auth/RefreshToken", {
          refreshToken: TokenService.getLocalRefreshToken(),
          IpAddress: ".",
        });

        const newAccessToken = rs.data.accessToken;
        TokenService.updateLocalTokens(rs.data);
        originalConfig.headers["Authorization"] = "Bearer " + newAccessToken;
        processQueue(null, newAccessToken);
        return axiosInstance(originalConfig);
      } catch (_error) {
        processQueue(_error, null);
        TokenService.removeUser();
        const redirect = encodeURIComponent(
          window.location.pathname + window.location.search,
        );
        window.location.href = `/giris?uyari=1&redirect=${redirect}`;
        return Promise.reject(_error);
      } finally {
        isRefreshing = false;
      }
    },
  );
};

export default setup;
